import React from 'react';
import cn from 'bem-cn';

import { Icon, Stack, Link } from '../../../components/UI';
import { Feed } from '../../../components/Feed';
import { usePromptFeedColumns } from '../../HomePage/HomePage.hooks';
import { NewPromptBanner } from '../../../components/NewPromptBanner';
import { useGetMyPromptsQuery } from '../../../store/services';

import './MyProfilePrompts.scss';

const b = cn('my-profile-prompts');

export const MyProfilePrompts: React.FC = () => {
    const { data: myPrompts = [], isLoading } = useGetMyPromptsQuery();

    const columns = usePromptFeedColumns();
    const correctedColumns = Math.min(columns, Math.max(2, myPrompts.length));

    const getSectionSize = () => {
        if (myPrompts.length < 3) {
            return 'small';
        }

        if (myPrompts.length === 3) {
            return 'medium';
        }

        return 'large';
    };

    return (
        <Stack spacing={24} className={b({ size: getSectionSize() })}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" className={b('header')}>
                <h2>Мои промпты</h2>
                {myPrompts.length > 1 && (
                    <Link to="/new" className="new-prompt-button">
                        <p>Новый промпт</p>
                        <Icon name="plus" size={24} fillColor="var(--accent-color)" />
                    </Link>
                )}
            </Stack>

            {!isLoading && myPrompts.length === 0 ? (
                <NewPromptBanner />
            ) : (
                <Feed
                    prompts={myPrompts}
                    columns={correctedColumns}
                    isLoading={isLoading}
                    showStatuses
                    showNewPromptCard={myPrompts.length === 1}
                />
            )}
        </Stack>
    );
};
